import moment from 'moment';

export default class Validator {

    rules = [
        'required',
        'email',
        'min-length',
        'max-length'
    ];

    errors = [];

    run(fields) {
        for (var i = 0; i < fields.length; i++) {
            var rules = fields[i][2].split('|');
            rules.forEach(rule => {
                var ruleAttr = rule.split(':');
                this.validate(fields[i][0], fields[i][1], ruleAttr[0], ruleAttr[1]);
            });
        }
        return this.errors;
    }

    validate(fieldName, fieldValue, rule, extra = '') {
        switch(rule) {
            case 'required':
                if(!this.required(fieldValue)) {
                    this.addError(fieldName, 'Bu alan zorunludur.');
                }
                break;
            case 'email':
                if(!this.email(fieldValue)) {
                    this.addError(fieldName, 'Geçersiz e-posta adresi.');
                }
                break;
            case 'min-length':
                if(!this.minLength(fieldValue, extra)) {
                    this.addError(fieldName, 'Bu alan en az ' + extra + ' karakter olmalıdır.');
                }
                break;
            case 'max-length':
                if(!this.maxLength(fieldValue, extra)) {
                    this.addError(fieldName, 'Bu alan en fazla ' + extra + ' karakter olabilir.');
                }
                break;
            case 'numeric':
                if(!this.numeric(fieldValue)) {
                    this.addError(fieldName, 'Bu alan nümerik olmalıdır.');
                }
                break;
            case 'date':
                if(!this.date(fieldValue)) {
                    this.addError(fieldName, 'Geçersiz tarih.');
                }
                break;
            case 'exact-length':
                if(!this.exactLength(fieldValue, extra)) {
                    this.addError(fieldName, 'Bu alan ' + extra + ' karakter olmalıdır.');
                }
                break;
        }
    }

    addError(field, errorMessage) {
        if (this.errors.length > 0) {
            var fieldExists = false;
            this.errors.forEach((error, i) => {
                if (error.field === field) {
                    this.errors[i].messages.push(errorMessage);
                    fieldExists = true;
                }
            });
            if (!fieldExists) {
                this.errors.push({
                    field: field,
                    messages: [errorMessage]
                });
            }
        } else {
            this.errors.push({
                field: field,
                messages: [errorMessage]
            });
        }
    }

    required(field) {
        if (typeof field === "undefined") {
            return false;
        }
        if (field === null) {
            return false;
        }
        if (field.length === 0 || field === '' || field === 0 || field === 'Seçiniz') {
            return false;
        }
        return true;
    }

    email(field) {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(!field.match(mailformat)) {
            return false;
        }
        return true;
    }

    maxLength(field, length) {
        if (field.length > length) {
            return false;
        }
        return true;
    }

    minLength(field, length) {
        if (field.length <= length) {
            return false;
        }
        return true;
    }

    numeric(field) {
        if(isNaN(field)) {
            return false;
        }
        return true;
    }

    date(field) {
        if(field === null) {
            return true;
        }
        return moment(field).isValid();
    }

    exactLength(field, extra) {
        if(field.length !== parseInt(extra)) {
            return false;
        }
        return true;
    }

}